__turbopack_context__.v({
  "arrowIcon": "PlasmicMobileDrawerItem-module__xxwttW__arrowIcon",
  "drawerItem": "PlasmicMobileDrawerItem-module__xxwttW__drawerItem",
  "drawerItemactive": "PlasmicMobileDrawerItem-module__xxwttW__drawerItemactive",
  "drawerItemexpanded": "PlasmicMobileDrawerItem-module__xxwttW__drawerItemexpanded",
  "drawerItemwithAccordion": "PlasmicMobileDrawerItem-module__xxwttW__drawerItemwithAccordion",
  "icon": "PlasmicMobileDrawerItem-module__xxwttW__icon",
  "iconexpanded": "PlasmicMobileDrawerItem-module__xxwttW__iconexpanded",
  "iconwithAccordion": "PlasmicMobileDrawerItem-module__xxwttW__iconwithAccordion",
  "itemWrapper": "PlasmicMobileDrawerItem-module__xxwttW__itemWrapper",
  "itemWrapperexpanded": "PlasmicMobileDrawerItem-module__xxwttW__itemWrapperexpanded",
  "itemWrapperwithAccordion": "PlasmicMobileDrawerItem-module__xxwttW__itemWrapperwithAccordion",
  "mobileDrawerItemSubItem": "PlasmicMobileDrawerItem-module__xxwttW__mobileDrawerItemSubItem",
  "submenu": "PlasmicMobileDrawerItem-module__xxwttW__submenu",
  "submenuexpanded": "PlasmicMobileDrawerItem-module__xxwttW__submenuexpanded",
  "text": "PlasmicMobileDrawerItem-module__xxwttW__text",
  "textWrapper": "PlasmicMobileDrawerItem-module__xxwttW__textWrapper",
  "textactive": "PlasmicMobileDrawerItem-module__xxwttW__textactive",
  "textexpanded": "PlasmicMobileDrawerItem-module__xxwttW__textexpanded",
  "textwithAccordion": "PlasmicMobileDrawerItem-module__xxwttW__textwithAccordion",
});
